module.exports = __webpack_public_path__ + "resources/img/img_spiceware_one_01_jp.c22ba369fc6ca71a50d544f54996b51b.png";